// extracted by mini-css-extract-plugin
module.exports = {"link":"_1g87PbH","iconSvg":"_1Ot8tr3"};
    if(module.hot) {
      // 1545369460267
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  